import * as actions from './actions'
import { ActionType, getType } from 'typesafe-actions'
// can be imported in the german version, since we will only use the language-independent IDs
import questions from 'locales/questions.de.yml'

export interface QuestionState {
  [id: string]: Set<string> | number | null
}

const defaultState = questions.reduce<QuestionState>(
  (map: QuestionState, q) => {
    map[q.id] = new Set()
    return map
  },
  {}
)
defaultState['aryaVictims'] = null

export function reducer(
  state: QuestionState = defaultState,
  action: ActionType<typeof actions>
) {
  if (action.type === getType(actions.selectAnswer)) {
    const { selectionType, questionId, clickedAnswer } = action.payload
    const answerSet = state[questionId] || new Set()
    // What type of selection are we dealing with?
    if (selectionType === 'multiple') {
      // Handle multiple selection

      if (answerSet.has(clickedAnswer)) {
        // Answer is already in set, remove it
        answerSet.delete(clickedAnswer)
      } else {
        // Add the answer in
        answerSet.add(clickedAnswer)
      }
    } else {
      // Handle single selection cases, so we remove all values and re-add the clicked answer
      answerSet.clear()
      answerSet.add(clickedAnswer)
    }

    return {
      ...state,
      [questionId]: answerSet
    }
  } else if (action.type === getType(actions.guessVictims)) {
    return {
      ...state,
      aryaVictims: action.payload
    }
  }

  return state
}
